import React from 'react';
import Select from 'react-select';

import './PrivacyTransfer.css';

function PrivacyTransfer(props) {

    let decoys = [];
    const options = [
        { value: 0, label: "0 decoys (security level `very low`)" },
        { value: 2, label: "2 decoys (security level `normal`)" },
        { value: 4, label: "4 decoys (security level `moderate`)" },
        { value: 6, label: "6 decoys (security level `pretty high`)" }
    ];

    const [amount, setAmount] = React.useState("");
    const [receiver, setReceiver] = React.useState("");
    const [selectedOption, setSelectedOption] = React.useState(options[1]);

    const changeAmount = (val) => {
        val = val.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
        console.log(val);
        setAmount(val);
    }

    React.useEffect(() => {
        // push 6 default decoys
        decoys.push("0x17f5f0daab7218a462dea5f04d47c9db95497833381f502560486d4019aec495"); 
        // parse from local storage `address book`
    });

    return (
        <div className="ghost-privacy-transfer-container">
	    <div className="ghost-privacy-transfer-header">
	        <div className="ghost-privacy-transfer-header-container">
	            <div className="ghost-privacy-transfer-header-container-title">Send Funds</div>
	            <div className="ghost-privacy-transfer-header-container-text">Send funds to any Astral account.</div>
	        </div>

	        <div className="ghost-privacy-transfer-balance">
	            <div className="ghost-privacy-transfer-balance-title">Balance</div>
	            <div className="ghost-privacy-transfer-balance-amount">3.2347 {props.asset}</div>
	        </div>

	    </div>
           
	    <div className="ghost-privacy-transfer-main">
	        <div className="ghost-privacy-transfer-main-receiver">
	            <input spellCheck="false" onChange={(val) => setReceiver(val.target.value)}  value={receiver} type="text" placeholder="Receiver addres (Astral address only)"></input>
	        </div>
	        <div className="ghost-privacy-transfer-main-amount">
	            <input onChange={(val) => changeAmount(val.target.value)} value={amount} type="text" placeholder="Amount"></input>
	        </div>
	    </div>

	    <div className="ghost-privacy-transfer-info">
	        <Select
	            defaultValue={selectedOption}
                    onChange={setSelectedOption}
                    options={options}
	            className={"ghost-privacy-dropdown"}
                />
	    </div>

	    <div className="ghost-propose-claim-buttons ghost-privacy-button-transfer">
	        <div onClick={() => {alert("transfered")}} className="ghost-propose-claim-buttons-button ghost-privacy-button-transfer-adapt">Transfer</div>
	    </div>

	</div>
    )
}

export default PrivacyTransfer;
